import { type CSSProperties, useLayoutEffect, useRef } from 'react';

export interface IMapHostOutletProps {
  /** Nodo DOM stabile che ospita la mappa (vedi `useMapExtendedView`). */
  hostNode: HTMLElement;
  style?: CSSProperties;
  /** Invocata dopo che il nodo è stato agganciato in questa posizione. */
  onAttach?: () => void;
}

/**
 * Punto di aggancio del nodo-mappa stabile. Quando questo outlet si monta (es.
 * passando da inline a Modal) sposta il `hostNode` nel proprio container via
 * `appendChild` — che sposta il nodo esistente senza ricrearlo, quindi senza
 * rimontare React né l'istanza OpenLayers. È sempre montato un solo outlet alla
 * volta (inline oppure Modal).
 */
export function MapHostOutlet(props: IMapHostOutletProps) {
  const { hostNode, style, onAttach } = props;
  const containerRef = useRef<HTMLDivElement>(null);

  useLayoutEffect(() => {
    const container = containerRef.current;
    if (container && hostNode.parentElement !== container) {
      container.appendChild(hostNode);
      onAttach?.();
    }
  }, [hostNode, onAttach]);

  return <div ref={containerRef} style={style} />;
}
